import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menu", "button" ]

  toggle() {
    this.menuTarget.classList.toggle("open")
    this.syncExpanded()
    this.returnFocusFromClosedMenu()
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.remove("open")
      this.syncExpanded()
    }
  }

  syncExpanded() {
    if (!this.hasButtonTarget) return

    this.buttonTarget.setAttribute("aria-expanded", this.menuTarget.classList.contains("open"))
  }

  // A chosen action hides with the menu, so focus goes back to the button rather than the page.
  returnFocusFromClosedMenu() {
    if (!this.hasButtonTarget || this.menuTarget.classList.contains("open")) return
    if (!this.element.contains(document.activeElement)) return

    this.buttonTarget.focus()
  }
}
